import { Button, Form, Table } from "react-bootstrap";
import "../listingTitle/listingtitle.scss";
import "./commonHeaderWithImpoExpo.scss";
import { ReactSVG } from "react-svg";
import exporticon from "../../assets/images/export-icon.svg";
import importicon from "../../assets/images/import-icon.svg";
import uploadfileicon from "../../assets/images/upload-file-icon.svg";
import CustomModal from "../customModal/CustomModal";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import { debounce } from "lodash";
import { useCallback, useMemo, useState } from "react";
const CommonHeaderWithImpoExpo = ({
  title,
  buttonTitle,
  href,
  disRecords,
  totalRecords,
  searchVal,
  setSearchVal,
  defaultFilter,
  isAddPermitted = true,
  exportList,
  importList,
  showImportFileModal,
  selectedFile,
  setSelectedFile,
  toggleImportXlsxModal,
  importErrorDetails,
  isImportPermitted = true,
  isExportPermitted = true
}: any) => {
  const navigate = useNavigate();
  const roleName = localStorage.getItem("roleName");
  const [localSearchText, setLocalSearchText] = useState(searchVal?.searchText ?? "");

  // Create a debounced version of the search handler
  const debouncedSearch = useMemo(
    () => debounce((value: string) => {
      setSearchVal({ ...searchVal, searchText: value });
    }, 500),
    [searchVal, setSearchVal]
  );

  // Handle search input change
  const handleSearchChange = useCallback((e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;
    setLocalSearchText(value);
    debouncedSearch(value);
  }, [debouncedSearch]);

  // Handle active checkbox change
  const handleActiveChange = useCallback((e: React.ChangeEvent<HTMLInputElement>) => {
    setSearchVal({
      ...searchVal,
      active: e.target.checked ? true : null,
    });
  }, [searchVal, setSearchVal]);

  // Handle clear all
  const handleClearAll = useCallback(() => {
    setLocalSearchText("");
    setSearchVal({ ...defaultFilter });
  }, [defaultFilter, setSearchVal]);

  const selectFile = (event: any) => {
    const file = event.target.files[0];

    // Check if file is selected
    if (!file) {
      toast.error("No file selected");
      return;
    }

    // Check file type (must be .xlsx)
    const fileType = file.type;
    if (
      fileType !==
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
    ) {
      toast.error("Please upload a valid .xlsx file");
      return;
    }

    // Check file size (must be <= 5MB)
    const fileSizeMB = file.size / (1024 * 1024); // convert to MB
    if (fileSizeMB > 5) {
      toast.error("File size must not exceed 5MB");
      return;
    }
    setSelectedFile(file);
  };

  const onImportClick = async(formData:any) =>{
    importList(formData);
  }
  const handleFileImport = async () => {
    onImportClick(selectedFile);
  };
  const onExportClick = async() => {
    exportList();  
  };
  return (
    <div className="listing-title-box">
      <div className="listing-title-info">
        <h2>{title}</h2>
        <p>
          Displaying {disRecords} of {totalRecords} Results
        </p>
      </div>
      <div className="listing-searchbar-wrapper">
        <div className="listing-searchbar-item-wrapper">
          <div className="listing-searchbar-item-box">
            <input
              type="text"
              min={0}
              className="form-control"
              placeholder="Search"
              onChange={handleSearchChange}
              value={localSearchText}
            />
          </div>
          <div>
            <div className="form-check form-check-inline">
              <input
                className="form-check-input"
                type="checkbox"
                checked={searchVal?.active ?? false}
                onChange={handleActiveChange}
              />
              <label className="form-check-label">Active</label>
            </div>
          </div>
          <Button
            type="button"
            variant="outline-secondary"
            className="btn-search"
            onClick={handleClearAll}
          >
            Clear All
          </Button>
        </div>
      </div>
      <div className="listing-action-box">      
        {(isImportPermitted || isExportPermitted) && (
          <div className="import-export-box-wrapper">
            {isImportPermitted && (
              <span
                className="import-export-btn import-btn"
                onClick={toggleImportXlsxModal}
              >
                <ReactSVG className="svg-box" wrapper="span" src={importicon} /> Import
              </span>
            )}
            {isExportPermitted && (
              <span
                className="import-export-btn export-btn"
                onClick={onExportClick}
              >
                <ReactSVG className="svg-box" wrapper="span" src={exporticon} /> Export
              </span>
            )}
          </div>
        )}

        {isAddPermitted && (
          <>
            <div className="action-box">
              <Button variant="primary" onClick={()=>navigate(href)}>
                <i className="bi bi-plus"></i>
                {buttonTitle}
              </Button>
            </div>
            {/* <div className="filter-box">
              <ReactSVG className="svg-box" wrapper="span" src={filtericon} />
            </div> */}
          </>
        )}
      </div>
      {showImportFileModal && (
        <CustomModal
          id="upload-avatar-modal"
          title="Import"
          content={
            <>
              <div className="modal--content--wrapper">
                <div className="img-upload-box">
                  <Form.Control
                    type="file"
                    id="avatar-upload-input"
                    accept=".xlsx"
                    onChange={selectFile}
                  />
                  <ReactSVG
                    className="svg-box"
                    wrapper="span"
                    src={uploadfileicon}
                  />
                  <p>Drag and Drop your file here or Click to Upload</p>
                </div>
                <div className="file-type-hint">
                  <span>File Type: .xlsx</span>
                  <span>Maximum Size: 5 MB</span>
                </div>
                {selectedFile?.name && (
                  <div className="file-type-hint">
                    <span>File Name: {selectedFile?.name}</span>
                  </div>
                )}
              </div>
              {importErrorDetails && importErrorDetails.data && importErrorDetails.data.length > 0 && (
                <div className="import-error-section">
                  <h3>Error Details</h3>
                  {importErrorDetails?.module?.toLowerCase() === 'users' && (
                    <Table responsive="md" hover={true} className="error-tbl">
                      <thead>
                        <tr>
                          <th>Name</th>
                          <th>UserName / Email</th>
                          <th>Error Message</th>
                        </tr>
                      </thead>
                      <tbody>
                        {importErrorDetails?.data?.map((data:any)=>(
                            <tr>
                              <td>{data?.fName} {data?.lName}</td>
                              <td>{data?.userName ? data?.userName :data?.email}</td>
                              <td className="error-info">{data?.errorMessage}</td>
                            </tr>
                        ))}
                      </tbody>
                    </Table>
                  )}
                  {importErrorDetails?.module?.toLowerCase() === 'locations' && (
                    <Table responsive="md" hover={true} className="error-tbl">
                      <thead>
                        <tr>
                          <th>Location Name</th>
                          <th>Location Code</th>
                          <th>Error Message</th>
                        </tr>
                      </thead>
                      <tbody>
                        {importErrorDetails?.data?.map((data:any)=>(
                          <tr>
                            <td>{data?.locationName}</td>
                            <td>{data?.locationCode}</td>
                            <td className="error-info">{data?.errorMessage}</td>
                          </tr>
                        ))}
                      </tbody>
                    </Table>
                  )}
                  {importErrorDetails?.module?.toLowerCase() === 'units' && (
                    <Table responsive="md" hover={true} className="error-tbl">
                      <thead>
                        <tr>
                          <th>Unit Id</th>
                          <th>Unit Name</th>
                          <th>Error Message</th>
                        </tr>
                      </thead>
                      <tbody>
                        {importErrorDetails?.data?.map((data:any)=>(
                          <tr>
                            <td>{data?.unitCode}</td>
                            <td>{data?.unitName}</td>
                            <td className="error-info">{data?.errorMessage}</td>
                          </tr>
                        ))}
                      </tbody>
                    </Table>
                  )}
                  <p>Please correct this data in excel sheet & try again..!</p>
                </div>
              )}
              <div className="modal--action--btn--wrapper">
                <Button
                  type="button"
                  variant="outline-primary"
                  onClick={toggleImportXlsxModal}
                >
                  Cancel
                </Button>
                <Button
                  type="button"
                  variant="primary"
                  onClick={handleFileImport}
                  disabled={!selectedFile}
                >
                  Import
                </Button>
              </div>
            </>
          }
          onClose={toggleImportXlsxModal}
        />
      )}
    </div>
  );
};

export default CommonHeaderWithImpoExpo;
